import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/app/components/ui/button';
import { KitForm } from '@/app/components/kits/kit-form';
import { useCreateKit, useAddAssetsToKit } from '@/hooks/use-kits';
import { toast } from '@/app/components/ui/simple-toaster';
import { PageBreadcrumb } from '@/app/components/page-breadcrumb';

export function CreateKitPage() {
  const navigate = useNavigate();
  const createMutation = useCreateKit();
  const addAssetsMutation = useAddAssetsToKit();

  const handleSubmit = async (data: { name: string; description?: string; assets: number[] }) => {
    try {
      const kit = await createMutation.mutateAsync({
        name: data.name,
        description: data.description,
      });

      if (data.assets.length > 0) {
        await addAssetsMutation.mutateAsync({
          id: kit.id,
          assetIds: data.assets,
        });
      }

      toast.success('Kit created successfully');
      navigate(`/kits/${kit.id}`);
    } catch {
      toast.error('Failed to create kit');
    }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <PageBreadcrumb items={[
        { label: 'Kits', href: '/kits' },
        { label: 'Create Kit' },
      ]} />
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/kits">
            <ArrowLeft className="h-5 w-5" />
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Create Kit</h1>
          <p className="text-gray-600">Create a new equipment kit</p>
        </div>
      </div>

      <KitForm
        onSubmit={handleSubmit}
        onCancel={() => navigate('/kits')}
        isSubmitting={createMutation.isPending || addAssetsMutation.isPending}
      />
    </div>
  );
}
